
// // AppHeader.jsx - Header with integrated MessagesBell component
// import React from "react";
// import { useLocation } from "react-router-dom";
// import "./AppHeader.css";
// import MessagesBell from "./messages/MessagesBell"; // ⭐ Import the MessagesBell component

// const AppHeader = ({ isSidebarVisible, toggleSidebar }) => {
//   const location = useLocation();
//   const { pathname } = location;

//   // Keep your existing logic for search visibility if needed
//   const showSearchForMembers = pathname.includes("members");
//   const showSearchForEvents = pathname.includes("events");

//   // =====================================================
//   // Callback for MessagesBell - closes sidebar before opening messages
//   // =====================================================
//   const handleBeforeOpenMessages = () => {
//     if (isSidebarVisible) {
//       toggleSidebar();
//     }
//   };

//   return (
//     <header
//       className="app-header"
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         width: "100%",
//         zIndex: 1000,
//         backgroundColor: "#01057a",
//         boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//         height: "120px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "0 20px",
//       }}
//     >
//       {/* Inner container for absolutely positioned children */}
//       <div
//         style={{
//           position: "relative",
//           width: "100%",
//           height: "100%",
//         }}
//       >
//         {/* Centered Logo (toggles sidebar on click) */}
//         <div
//           onClick={toggleSidebar}
//           style={{
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             flexShrink: 0,
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//           }}
//         >
//           {/* <img
//             src="/images/onscreen.png"
//             alt="On Screen"
//             style={{
//               height: "55px",
//               width: "auto",
//               maxWidth: "210px",
//               objectFit: "contain",
//               display: "block",
//             }}
//           /> */}
//           <img
//             src="/images/on-screen-logo.png"
//             alt="On Screen"
//             style={{
//               height: "120px",
//               width: "auto",
//               maxWidth: "350px",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </div>

//         {/* 
//           ⭐ Message Bell Component - fixed to top-right 
          
//           This MessagesBell component:
//           - Automatically turns ORANGE (#ff6800) when unread count > 0
//           - Automatically turns WHITE when unread count = 0
//           - Polls backend every 30 seconds for updated count
//           - Listens for real-time events (new-message, message-read, unread:refresh)
//           - Shows badge with count when there are unread messages
//           - Closes sidebar before opening messages modal
//         */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             right: 0,
//             height: "100%",
//             display: "flex",
//             alignItems: "flex-start",
//             justifyContent: "flex-end",
//             flexShrink: 0,
//             paddingTop: "8px",
//             paddingRight: "8px",
//           }}
//         >
//           <MessagesBell 
//             size={28} 
//             onBeforeOpen={handleBeforeOpenMessages}
//           />
//         </div>
//       </div>
//     </header>
//   );
// };

// export default AppHeader;


// AppHeader.jsx - Header with integrated MessagesBell component
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./AppHeader.css";
import MessagesBell from "./messages/MessagesBell"; // ⭐ Import the MessagesBell component

const AppHeader = ({ isSidebarVisible, toggleSidebar, hideMessagesBell = false, disableSidebarToggle = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  // Keep your existing logic for search visibility if needed
  const showSearchForMembers = pathname.includes("members");
  const showSearchForEvents = pathname.includes("events");

  // =====================================================
  // Callback for MessagesBell - closes sidebar before opening messages
  // =====================================================
  const handleBeforeOpenMessages = () => {
    if (isSidebarVisible) {
      toggleSidebar();
    }
  };

  // Handle logo click: navigate to login if sidebar toggle is disabled (public member pages)
  const handleLogoClick = () => {
    if (disableSidebarToggle) {
      navigate('/login');
    } else {
      toggleSidebar();
    }
  };

  return (
    <header
      className="app-header"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 1000,
        backgroundColor: "#01057a",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        height: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 20px",
      }}
    >
      {/* Inner container for absolutely positioned children */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        {/* Centered Logo (toggles sidebar on click, or navigates to login on public pages) */}
        <div
          onClick={handleLogoClick}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexShrink: 0,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {/* <img
            src="/images/onscreen.png"
            alt="On Screen"
            style={{
              height: "55px",
              width: "auto",
              maxWidth: "210px",
              objectFit: "contain",
              display: "block",
            }}
          /> */}
          <img
            src={`${process.env.PUBLIC_URL}/images/on-screen-logo.png`}
            alt="On Screen"
            style={{
              height: "120px",
              width: "auto",
              maxWidth: "350px",
              objectFit: "contain",
              display: "block",
              WebkitTransform: "translateZ(0)",
              transform: "translateZ(0)",
              backfaceVisibility: "hidden",
              WebkitBackfaceVisibility: "hidden",
              imageRendering: "-webkit-optimize-contrast",
            }}
            loading="eager"
            onError={(e) => {
              console.error("Logo failed to load:", e);
              e.target.style.display = "none";
            }}
          />
        </div>

        {/* 
          ⭐ Message Bell Component - fixed to top-right 
          
          This MessagesBell component:
          - Automatically turns ORANGE (#ff6800) when unread count > 0
          - Automatically turns WHITE when unread count = 0
          - Polls backend every 30 seconds for updated count
          - Listens for real-time events (new-message, message-read, unread:refresh)
          - Shows badge with count when there are unread messages
          - Closes sidebar before opening messages modal
        */}
        {!hideMessagesBell && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              height: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-end",
              flexShrink: 0,
              paddingTop: "8px",
              paddingRight: "8px",
            }}
          >
            <MessagesBell
              size={28}
              onBeforeOpen={handleBeforeOpenMessages}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default AppHeader;